import { render, staticRenderFns } from "./Popupitems.vue?vue&type=template&id=14dbfea4&scoped=true&"
import script from "./Popupitems.vue?vue&type=script&lang=js&"
export * from "./Popupitems.vue?vue&type=script&lang=js&"
import style0 from "./Popupitems.vue?vue&type=style&index=0&id=14dbfea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dbfea4",
  null
  
)

component.options.__file = "Popupitems.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VCardTitle,
  VDialog,
  VForm,
  VIcon,
  VTextField,
})
